import isEmpty from "lodash/isEmpty";
import userflow from "userflow.js";

import { isUserflowActive } from "./config";

/**
 * Build Userflow attributes from the active role (deployment, saleyard, agency, role type).
 * Used for flow filtering. Identification is always by USER id.
 * Role data is sent as attributes so flows can target by role/saleyard/deployment/agency.
 */
function getActiveRoleAttributes(activeRole) {
  if (!activeRole) {
    return {};
  }

  const deployments = activeRole.deployments || [];
  const saleyards = activeRole.saleyards || [];
  const agencies = activeRole.agencies || [];
  const channels = activeRole.channels || [];

  const attributes = {
    role_type: String(activeRole.type ?? ""),
    role_slug: String(activeRole.slug ?? ""),
    deployment_ids: deployments.map(deployment => deployment.id),
    deployment_names: deployments.map(deployment => deployment.name),
    saleyard_ids: saleyards.map(saleyard => saleyard.id),
    saleyard_names: saleyards.map(saleyard => saleyard.name),
    agency_names: agencies.map(agency => agency.agency_name),
    channels,
  };

  return Object.entries(attributes).reduce((acc, [key, value]) => {
    if (!isEmpty(value)) {
      acc[key] = value;
    }
    return acc;
  }, {});
}

export function identifyUserToUserflow(currentUser, activeRole) {
  if (!isUserflowActive) {
    return;
  }

  const {
    user_id: userId,
    email,
    first_name: firstName,
    last_name: lastName,
    date_joined: dateJoined,
  } = currentUser;

  if (userId == null) {
    return;
  }

  const name =
    firstName && lastName
      ? `${firstName} ${lastName}`
      : firstName || lastName || undefined;

  const signedUpAt = dateJoined
    ? new Date(dateJoined).toISOString()
    : undefined;

  const attributes = {
    name,
    email,
    signed_up_at: signedUpAt,
    ...getActiveRoleAttributes(activeRole ?? null),
  };

  userflow.identify(String(userId), attributes);
}
